import React from "react";
import { History, MapPinned, ShieldCheck, Wrench } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const trustIndicators = [{
  icon: History,
  title: "+36 Anos",
  description: "Experiência consolidada em engenharia térmica e refrigeração para ambientes críticos."
}, {
  icon: MapPinned,
  title: "Atuação LATAM",
  description: "Presença em todo o Brasil e na America Latina, com suporte técnico ágil e logística eficiente."
}, {
  icon: ShieldCheck,
  title: "Aplicações Críticas",
  description: "Especialistas em áreas médico-hospitalares, salas limpas e datacenters."
}, {
  icon: Wrench,
  title: "Suporte Técnico",
  description: "Equipe de engenharia dedicada para manutenção, retrofit e comissionamento."
}];
export default function CardGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="grade-de-cartões" className="bg-secondary/50 relative overflow-hidden py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={cn("grid grid-cols-1 gap-8 md:grid-cols-2 lg:gap-12 max-w-5xl mx-auto transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {trustIndicators.map((item, i) => <div key={i} data-index={i} className="h-full">
              <Card className="group relative h-full overflow-hidden rounded-sm border border-border bg-background shadow-2xs transition-all duration-300 hover:-translate-y-1">
                <CardContent className="flex flex-col items-center justify-center p-8 text-center md:p-12">
                  <div className="mb-8 rounded-full bg-primary/10 p-5 transition-colors duration-300 group-hover:bg-primary/15">
                    <item.icon strokeWidth={1.5} className="text-primary size-12 transition-colors duration-300" />
                  </div>
                  
                  <h3 className="text-foreground mb-4 text-2xl font-bold tracking-tight md:text-3xl">
                    {item.title}
                  </h3>
                  
                  <p className="text-muted-foreground max-w-xs text-base leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}